import { errHandler, isEmpty } from "utils/common";
import api from "utils/api";

/**
 * Builds FormData from a plain payload object.
 * Serializes larvicide_entries as a single JSON string (including empty list "[]"),
 * while preserving multi-value array appends for keys like intervention_done
 * and skipping empty values.
 *
 * @param {Record<string, any>} payload
 * @returns {FormData}
 */
export const buildFormData = (payload = {}) => {
  const data = new FormData();
  for (const [key, val] of Object.entries(payload)) {
    if (key === "larvicide_entries") {
      if (Array.isArray(val)) {
        data.append(key, JSON.stringify(val));
      } else if (!isEmpty(val)) {
        data.append(key, typeof val === "string" ? val : JSON.stringify(val));
      }
      continue;
    }

    if (!isEmpty(val)) {
      if (Array.isArray(val)) {
        val.forEach((e) => {
          if (e) data.append(key, e);
        });
      } else {
        data.append(key, val);
      }
    }
  }
  return data;
};

export default class LarvaBreeding {
  getAll = (opt = { page: 1, limit: 10, searchBy: "", searchValue: "" }) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/vector_larva_interventions`, { params: opt })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  getOne = (id) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/vector_larva_intervention/${id}`)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  add = (payload) => {
    return new Promise((resolve, reject) => {
      const data = buildFormData(payload);

      api
        .post(`/api/vector_larva_intervention?device=Online`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  update = (payload, id) => {
    return new Promise((resolve, reject) => {
      const data = buildFormData(payload);

      api
        .patch(`/api/vector_larva_intervention/${id}?device=Online`, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  remove = (id) => {
    return new Promise((resolve, reject) => {
      api
        .delete(`/api/vector_larva_intervention/${id}?device=Online`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  getImage = (id) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/vector_larva_intervention/image/${id}`, {
          responseType: "blob",
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  getImageLarva = (id) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/vector_larva_intervention/image_larva/${id}`, {
          responseType: "blob",
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
}
